<template>
    <div class="animated fadeIn scroll" :style="divstyle">
        <b-modal size="lg" title="Attenzione" class="modal-info" v-model="forzaDoc" @ok="docOK = true, forzaDoc = false, savemod()">
            Non sei il docente assegnato a quest'ora: vuoi forzare l'inserimento ?
        </b-modal>
        <b-modal size="lg" title="Inserimento modulo e argomento" class="modal-info" v-model="insmod" @ok="savemod" :ok-only="false" :ok-disabled="insargokdis" ok-title="Salva">
            <div>
                Modulo:
                <multiselect id="modulilist" v-model="currmod" :options="availmods" :multiple="false" :searchable="false" :allow-empty="false" :deselectLabel="''" :close-on-select="true"
                    :disabled="!canchangemod || !docOK" label="nome" track-by="moduloid" @input="favmodsel"></multiselect>
            </div>
            Argomento:
            <template>
                <textarea class="argomento" rows=8 v-model="argomento" :disabled="insmodRO"></textarea>
            </template>
        </b-modal>
        <b-modal title="Errore durante il salvataggio" class="modal-danger" v-model="errShow" @ok="errShow = false" ok-variant="danger" :ok-only="true">
            {{ errMessage }}
            <!-- div slot="modal-cancel">CANCEL</div -->
        </b-modal>
        <div v-if="loading">
            <semipolar-spinner :animation-duration="2000" :size="65" color="#ff1d5e" />Loading...
        </div>
        <div v-if="!loading">
            <h1>
                Registro Argomenti {{ loctime.toFormat('dd/MM/yyyy') }}
                <span v-if="noprogsel">{{ progsel.nome }}</span>
            </h1>
            <span v-if="!noprogsel">
                <hr />Progetto:
                <multiselect id="progettilist" v-model="progsel" :options="progetti" :multiple="false" :close-on-select="true" label="nome" track-by="progettoid" :disabled="noprogsel"
                    @input="fprogsel">
                </multiselect>
            </span>
            <b-alert :show="dismissCountDown2" dismissible @dismissed="dismissCountDown2 = 0" @dismissCountDown="countDownChanged2" variant="danger">
                Non sei il docente previsto per quest'ora
            </b-alert>
            <!-- prospetto moduli della giornata -->
            <table class="prospettomoduli" v-if="cals && cals.length && !tuttochiuso" border=1>
                <tr v-for="c of cals" :key="c.ora">
                    <th>
                        <template v-if="!tuttochiuso">
                            <button v-if="!GREEN || !c.argomento" class="btn btn-info" @click="setmod(c)">
                                {{ c.orad }} - {{ c.nome }}
                            </button>
                            <button v-else class="btn btn-primary" @click="setmod(c)">
                                {{ c.orad }} - {{ c.nome }}
                            </button>
                        </template>
                        <template v-else>
                            <span @click="viewmod(c)" :class="liv7">{{ c.ora }} - {{ c.nome }}</span>
                        </template>
                    </th>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
import { API } from "@/api.js";
import { SemipolarSpinner } from "epic-spinners";
import { DateTime } from "luxon";

const NOSOFTSKILLS = true

export default {
    name: "dashboard",
    mixins: [window.myMixin],
    components: {
        SemipolarSpinner,
    },
    data: function () {
        return {
            ritardo10alid: 0,
            ritardo10nome: "",
            ritardo10conf: false, ritardo10alid: 0,
            ora: 0,
            oraToSave: null,
            tuttochiuso: false, // se ho fatto il secondo scruitinio chiudo tutto a prescindere
            dataChiuso: '2000-01-01', // i progetti con datascrutinio possono modificarla
            dataChiuso2: '2000-01-01', // i progetti con datascrutinio2 possono modificarla
            fad: [],
            fadscores: [],
            fadindicatori: [],
            insdata: "",
            insnota: "",
            notaaid: 0,
            insnote: false,
            noprogsel: false,
            loading: false,
            errMessage: false,
            errShow: false,
            cseen: false,
            aseen: {},
            anote: [],
            cnote: [],
            progsel: {},
            modsel: [],
            progetti: [],
            moduli: [],
            alunni: [],
            voti: {},
            medie: {},
            docs: [],
            vdescr: [],
            vhmdescr: [],
            mvdescrShow: false,
            mvdescr: { mid: false, data: false, descr: "" },
            dmvdescr: "",
            dforzamedia: false,
            dforzamediadel: false,
            daddvoto: false,
            dwhat: {},
            dwhatv: {},
            showmedie: true,
            barcache: {},
            barmediacache: {},
            forceUpdate: 0,
            cals: [], // elenco orario-modulo
            pres: {}, // elenco presenze ( pres[corsista]['09:00'] = { presenteoraintera: false, giustificato:true })
            dismissCountDown: 0,
            dismissCountDown2: 0,
            // ----- dati per la dialog modifica moduli e microprogettazione
            insmod: false,
            insmodRO: false,
            currmod: false,
            availmods: [],
            microprog: [],
            htmlcon: "",
            showcon: false,
            availcons: [],
            votiuf: [], // voti delle uf calcolati (per ENAC) con rapporto 30/70 fra hm e classe
            currcal: false,
            currcon: false,
            currarg: false,
            availargs: [],
            argomento: "",
            eliminaobj: false,
            soloquestoalunnoid: false,
            soloquestomoduloid: false,
            docOK: false,
            forzaDoc: false,
            modcomp: [], // tabella di corrispondenza fra moduli in comune
            modulijoin: {},
            saving: [],
            giustifiche: [],
            giustifichedett: [], // dettaglio su entra/esce e ora
        };
    },
    props: ["noframe"],
    watch: {
        dwhatv: function (newVal, oldVal) {
            // watch it
            this.dwhatv;
            if (newVal.cancel) {
                this.daddvoto = false;
            } else if (newVal.data != "" && !newVal.ro) {
                this.addvoto2();
            }
        }
    },
    filters: {
        itadata: function (value) {
            if (!value || value == "") return "";
            return value
                .split("-")
                .reverse()
                .join("/");
        }
    },
    computed: {
        fmodsel() {
            return this.modsel.filter(a => this.soloquestomoduloid == false || a.moduloid == this.soloquestomoduloid)
        },
        liv7() {
            return this.getUserLIV() >= 7 ? "liv7" : ""
        },
        canchangemod() {
            let cal = this.cals.find(c => c.ora == this.oracorrente)
            console.log("canchangemod", this.cals, cal, this.oracorrente)
            // docid0 contiene l'eventuale docente sostituito per malattia: se esiste allora si tratta di una supplenza a NON devo poter cambiaree il modulo !!
            return !!cal && !cal.docid0
        },
        insargokdis() {
            return this.argomento.trim() == "" || this.insmodRO
        },
        loctime() {
            if (window.DEBUG)
                return window.loctime || DateTime.local()
            else
                return window.loctime_par || DateTime.local() // loctime passato come parametro (per debug, ma su versione di produzione)
        },
        caninsert: function () {
            return window.FORMVOTIALUNNI_CANINSERT == 1 && !this.tuttochiuso;
        },
        divstyle: function () {
            return `height: calc(100vh - ${this.noframe ? 50 : 180}px);`;
        },
        loctimeSQL() {
            return this.loctime.toFormat('yyyy-MM-dd HH:mm:ss')
        },
        locdateSQL() {
            return this.loctime.toFormat('yyyy-MM-dd')
        },
        adesso: function () {
            return this.loctime
                .plus({ days: 1 })
                .toISODate();
        },
        oracorrente: function () {
            // se ho già il calendario, calcolo l'ora corrente in base a quello (per tenere conto delle mezz'ore)
            if (this.cals && this.cals.length > 0) {
                let adesso = this.loctime.get('hour') * 60 + this.loctime.get('minute')
                console.log("adesso", adesso)
                for (let c of this.cals) {
                    let cora = c.ora.split(":")[0] * 60 + c.ora.split(":")[1] * 1
                    console.log(c.ora, c.ora.split(":")[0] * 60, cora, cora - adesso)
                    if (adesso > cora && adesso - cora < 60) {
                        return c.ora
                    }
                }
            }
            return this.loctime.toFormat('HH:00')
        },
        mindata: function () {
            if (this.forceUpdate < 0) return null; // serve solo per attivare la chiamata
            // la routine si mangia un giorno
            let ret = DateTime.fromISO(window.FORMVOTIALUNNI_PRIMOSEMESTRE == 1 ?
                window.FORMVOTIALUNNI_dpickerannomin + '-' + window.FORMVOTIALUNNI_dpickermesemin + '-' + window.FORMVOTIALUNNI_dpickergiornomin
                :
                window.FORMVOTIALUNNI_DATAFINESEM + 'T23:59:59.999').plus({ days: 1 }).toISODate();
            console.log("mindata", ret, this.forceUpdate)
            return ret
        }
    },
    methods: {
        splitargs(args) { // gli argomenti
            let ret = args ? args.split("|").map((a, i) => ({ argid: i, text: a })) : []
            console.log("availargs", ret)
            return ret
        },
        async setmod(c) { // serve a scegliere il modulo  e/o ad impostare conoscenza ed argomento
            console.log("setmod", c, this.oracorrente)
            let cal = this.cals.find(c => c.ora == this.oracorrente)
            this.curcal = cal
            console.log("cal", cal, this.getUserID(), this.getUserLIV())
            //   console.log("cals", this.cals)

            if (c.docid != this.getUserID() && this.getUserLIV() < 2) {
                this.viewmod(c)
                return
            }
            // i moduli previsti secondo il docente a calendario  

            // verifico se è un modulo doppio
            let mdbl = !!this.modulijoin[c.moduloid]
            console.log("isDBL:", mdbl)

            var mods
            if (this.ENAC) {
                mods = await API.sqlprep(this, "registroc.selmodsdoc", [this.progsel.progettoid, this.progsel.progettoid, c.docid]);
                // ora ho le ore del modulo, quelle del calendario e quelle dell'incarico... filtro i moduli che non posso selezionare (ma lascio quello corrente!)
                // 2024-10-17: solo i moduli che hanno ancora ore di incarico disponibili
                mods.data.dati = mods.data.dati.filter(m => m.moduloid == c.moduloid || m.orecaltodo > 0)
            } else {
                mods = await API.sqlprep(this, "registro.selmodsdoc", [this.progsel.progettoid, c.docid]);
            }
            if (mdbl)
                this.availmods = mods.data.dati.filter(m => !!this.modulijoin[m.moduloid])
            else
                this.availmods = mods.data.dati.filter(m => !this.modulijoin[m.moduloid])

            console.log("availmods!", this.availmods)
            await this.favmodsel()
            console.log("favmodsel called")
            this.currmod = this.availmods.find(am => am.moduloid == c.moduloid)
            console.log("currmod!", this.currmod)
            // vedo se avevo già salvato qualcosa

            var args = await API.sqlprep(this, "registro.selarg", [c.calid]);
            if (args.data.dati.length > 0) {
                this.argomento = args.data.dati[0].argomento
                let modid = args.data.dati[0].moduloid
                let mmpid = args.data.dati[0].mmpid
                let mmps = await API.sqlprep(this, "registro.selmicro", [modid]);
                this.currcon = mmps.data.dati.find(m => m.mmpid == mmpid)
                console.log("currcon", this.currcon)
                // gli argomenti prima erano gli "strumenti"
                if(this.currcon) {
                    this.availargs = this.splitargs(this.currcon.strumenti)
                    this.currarg = this.availargs.find(aa => aa.text == args.data.dati[0].argomento)
                }
            } else {
                this.argomento = ""
                this.currarg = false
                this.favmodsel()
            }
            this.insmodRO = false
            this.insmod = true
            this.oraToSave = c.ora // NON devo salvare l'ora corrente, ma quella che ho editato !
            this.docOK = c.docid == this.getUserID()
        },
        async viewmod(c) { // serve SOLO a vedere modulo, conoscenza ed argomento
            console.log("viewmod", c)
            var mods = await API.sqlprep(this, "registro.selmodsdoc", [this.progsel.progettoid, c.docid]);
            this.availmods = mods.data.dati
            console.log("availmods", this.availmods)
            this.currmod = this.availmods.find(am => am.moduloid == c.moduloid)
            console.log("currmod", this.currmod)
            // vedo se avevo già salvato qualcosa
            var args = await API.sqlprep(this, "registro.selarg", [c.calid]);
            console.log("args:", args.data.dati)
            if (args.data.dati.length > 0) {
                this.argomento = args.data.dati[0].argomento
                let modid = args.data.dati[0].moduloid
                let mmpid = args.data.dati[0].mmpid
                let mmps = await API.sqlprep(this, "registro.selmicro", [modid]);
                this.currcon = mmps.data.dati.find(m => m.mmpid == mmpid)
                console.log("currcon", this.currcon)
                this.availargs = this.splitargs(this.currcon.strumenti)
                this.currarg = this.availargs.find(aa => aa.text == args.data.dati[0].argomento)
            } else {
                this.argomento = ""
                this.currcon = false
                this.currarg = false
                this.favmodsel()
            }
            this.insmodRO = true
            this.insmod = true
        },
        async favmodsel() {
            console.log("scelto un altro modulo", this.currmod)
            if (this.currmod) {
                var mmp = await API.sqlprep(this, "registro.selmicro", [
                    this.currmod.moduloid,
                ]);
                this.availcons = mmp.data.dati
            } else {
                this.availcons = []
            }
            this.currcon = null
            this.currarg = null
            this.argomento = ''
        },
        async favconsel() {
            console.log("scelta un'altra conoscenza", this.currcon)
            if (this.currcon) {
                this.availargs = this.splitargs(this.currcon.strumenti)
                this.currarg = null
                this.argomento = ''
            }
        },
        async favargsel() {
            console.log("scelto l'argomento", this.currarg)
            if (this.currarg) {
                this.argomento = this.currarg.text
            } else {
                this.argomento = ''
            }
        },
        async savemod() {
            // se non è il doc corretto, chiedo una conferma !
            if (!this.docOK) {
                this.forzaDoc = true
                return
            }
            console.log("aggiorno i dati", this.currcon, this.cals, this.oracorrente, this.oraToSave)
            let cal = this.cals.find(c => c.ora == this.oraToSave)
            let cmid = this.currmod.moduloid // il modulo potrebbe NON essere quello del calendario
            // la salvaarg si occupa anche di aggiornare il modulo a calendario, se serve
            // divisa in 5 chiamate perché è formata da più statements
            var res
            res = await API.sqlprep(this, "registro.salvaarg1", []);
            res += await API.sqlprep(this, "registro.salvaarg2", [cal.calid]);
            res += await API.sqlprep(this, "registro.salvaarg3", [cmid, cal.calid]);
            res += await API.sqlprep(this, "registro.salvaarg4", [cal.calid, this.currcon ? this.currcon.mmpid : null, !this.ECFOP ? this.argomento : (this.currarg ? this.currarg.text : ""), cmid]);
            res += await API.sqlprep(this, "registro.salvaarg5", []);
            console.log("RES", res)
            // se ho cambiato il modulo, devo ricaricare i cals
            if (cal.moduloid != cmid) {
                console.log("Il modulo è cambiato....")
                if (this.ECFOP) {
                    var cals = await API.sqlprep(this, "registro.selcalnostage", [
                        this.progsel.progettoid,
                        this.loctimeSQL
                    ]);
                } else if (this.GREEN) {
                    var cals = await API.sqlprep(this, "registrog.selcal", [
                        this.progsel.progettoid,
                        this.loctimeSQL
                    ]);
                } else {
                    var cals = await API.sqlprep(this, "registro.selcal", [
                        this.progsel.progettoid,
                        this.loctimeSQL
                    ]);
                }
                console.log("CALS", cals.data.dati)
                this.cals = cals.data.dati
            } else if(this.GREEN) {
                // rileggo perché la grafica riflette la presenza dell'argomento
                let rselcal = "registrog.selcalnostage"
                var cals = await API.sqlprep(this, rselcal, [
                    this.progsel.progettoid,
                    this.loctimeSQL
                ]);
                this.cals = cals.data.dati
            }
            this.insmod = false
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        countDownChanged2(dismissCountDown2) {
            this.dismissCountDown2 = dismissCountDown2
        },
        selOpts(ind) {
            return this.fad.filter(f => f.indicatore == ind).map(f => f.testo)
        },
        chiuso(p) {
            return this.dataChiuso >= p.data || p.chiusura || p.chiusura1 || p.chiusura2 || this.tuttochiuso; // pagellahm o pagella
        },
        chiuso2(p) {
            return this.dataChiuso2 >= p.data || p.chiusura || p.chiusura1 || p.chiusura2 || this.tuttochiuso; // pagellahm o pagella
        },
        salva: async function (home, aid, mid, v, d) {
            if (mid >= 0 && d == "") return;
            if (v > 100) v = 100;
            if (v < 0) v = 0;
            var sql;
            var pars;
            var repls;
            if (mid == -2 || mid == -3 || mid == -4) {
                // per ora ECFOP le salva al contrario: dovrò aggiustarle aggiornando anche il DB
                var uf = "uf" + (mid + 5);
                if (window.ENAC)
                    uf = "uf" + (-1 - mid);
                var ret = await API.sqlprep(
                    this,
                    "registro.ppfins",
                    [aid, v, this.getUserID()],
                    { "@uf": uf }
                );
                repls = { "@uf": uf };
                pars = [v, this.getUserID(), aid];
                sql = "registro.ppfupd";
            } else if (mid == -8 || mid == -9 || mid == -10) {
                // per ora ECFOP NON HA le UF4-6
                var uf = "uf" + (-4 - mid);
                var ret = await API.sqlprep(
                    this,
                    "registro.ppfins",
                    [aid, v, this.getUserID()],
                    { "@uf": uf }
                );
                repls = { "@uf": uf };
                pars = [v, this.getUserID(), aid];
                sql = "registro.ppfupd";
            } else if (mid == -8 || mid == -9 || mid == -10) {
                var uf = "uf" + (mid + 14);
                var ret = await API.sqlprep(
                    this,
                    "registro.ppfins",
                    [aid, v, this.getUserID()],
                    { "@uf": uf }
                );
                repls = { "@uf": uf };
                pars = [v, this.getUserID(), aid];
                sql = "registro.ppfupd";
            } else if (mid == -1) {
                if (v > 1) v = 1;
                var ret = await API.sqlprep(
                    this,
                    "registro.ppfins",
                    [aid, v, this.getUserID()],
                    { "@uf": "pwork" }
                );
                repls = { "@uf": "pwork" };
                pars = [v, this.getUserID(), aid];
                sql = "registro.ppfupd";
            } else if (mid == -5) {
                if (v > 100) v = 100;
                var ret = await API.sqlprep(
                    this,
                    "registro.ppfins",
                    [aid, v, this.getUserID()],
                    { "@uf": "condotta" }
                );
                repls = { "@uf": "condotta" };
                pars = [v, this.getUserID(), aid];
                sql = "registro.ppfupd";
            } else if (mid == -7) { //ENAC
                if (v > 100) v = 100;
                var ret = await API.sqlprep(
                    this,
                    "registro.ppfins",
                    [aid, v, this.getUserID()],
                    { "@uf": "irc" }
                );
                repls = { "@uf": "irc" };
                pars = [v, this.getUserID(), aid];
                sql = "registro.ppfupd";
                pars = [v, this.getUserID(), aid];
                sql = "registro.ppfupd";
            } else if (mid == -6) { //ENAC
                if (v > 100) v = 100;
                var ret = await API.sqlprep(
                    this,
                    "registro.ppfins",
                    [aid, v, this.getUserID()],
                    { "@uf": "stage" }
                );
                repls = { "@uf": "stage" };
                pars = [v, this.getUserID(), aid];
                sql = "registro.ppfupd";
            } else if (home) {
                repls = { "@hm": "hm" };
                // elimino (in caso di update)
                if (window.ENAC) {
                    pars = [aid, aid, mid, d];
                    await API.sqlprep(this, "registroc.pagelladel", pars, repls);
                } else {
                    pars = [aid, mid, d];
                    await API.sqlprep(this, "registro.pagelladel", pars, repls);
                }
                pars = [aid, mid, d, v, this.getUserID()];
                sql = window.ENAC ? "registroc.pagellains" : "registro.pagellains";
            } else if (mid > 2) {
                // 2020-06-03 - NON faccio update sui 999999 (mod.rel.)
                repls = { "@hm": "" };
                if (mid != 999999) {
                    // elimino (in caso di update)
                    if (window.ENAC) {
                        pars = [aid, aid, mid, d];
                        await API.sqlprep(this, "registroc.pagelladel", pars, repls);
                    } else {
                        pars = [aid, mid, d];
                        await API.sqlprep(this, "registro.pagelladel", pars, repls);
                    }
                }
                pars = [aid, mid, d, v, this.getUserID()];
                sql = window.ENAC ? "registroc.pagellains" : "registro.pagellains";
            } else if (mid >= 0) {
                // elimino (in caso di update)
                pars = [aid, mid, d];
                sql = "registro.pagellaapprdel";
                var ret = await API.sqlprep(this, sql, pars, repls);
                pars = [aid, mid, d, v, this.getUserID()];
                sql = "registro.pagellaapprins";
            }
            var ret = await API.sqlprep(this, sql, pars, repls);
            if (!this.testErr(ret, mid)) {
                if (mid >= 0) {
                    // i voti sono tutti via con il codice del modulo del progetto, anche se sono del progetto parallelo
                    mid = this.modcomp[mid] || mid
                    var l = this.voti["A" + aid]["M" + mid].length;
                    var ret = {
                        alunnoid: aid,
                        moduloid: mid,
                        docenteid: this.getUserID(),
                        voto: v,
                        data: d,
                        hm: home
                    };
                    // cerco il voto: se c'è già lo sostituisco, altrimenti lo aggiorno
                    var i = this.voti["A" + aid]["M" + mid].findIndex(vv => vv.data == d && vv.hm == home)
                    if (i >= 0) {
                        this.voti["A" + aid]["M" + mid][i] = ret
                    } else
                        this.voti["A" + aid]["M" + mid].splice(l - 1, 0, ret);
                }
                return ret;
            } else {
                return false;
            }
        },
        testErr: function (ret, mid) {
            if (ret.data.errInfo[2] !== null || ret.data.cerrInfo[2] !== null) {
                this.errMessage =
                    (ret.data.errInfo[2] || "") + (ret.data.cerrInfo[2] || "");
                if (mid == 999999)
                    this.errMessage = "Errore: data già presente. Utilizzarne una diversa"
                this.errShow = true;
                return true;
            } else {
                return false;
            }
        },
        ifmodsel: function () {
            console.log("MSEL:", this.modsel);
            localStorage.setItem(
                "registro_pid" + this.progsel.progettoid,
                JSON.stringify(this.modsel)
            );
        },
        fprogsel: async function () {
            this.modcomp = []
            //this.$nextTick(async () => {
            this.loading = true;
            console.log("PROGSEL:", this.progsel);

            // aggiorno i parametri tenendo conto che alcuni possono essere specifici al progetto
            await API.getpars(this, this.progsel.sedeid)

            // aggiorno le impostazioni in base alla data scrutinio (se presente nel progetto)
            let adesso = this.loctime

            var mods = await API.sqlprep(this, "registro.selmods", [this.progsel.progettoid]);
            var moduli = mods.data.dati
                .map(m => ({
                    moduloid: m.moduloid,
                    nome: m.nome,
                    codice: m.codice,
                    area: m.area
                }))
                .sort((a, b) => {
                    if (a.codice < b.codice) return -1;
                    else if (a.codice > b.codice) return 1;
                    else return 0;
                });



            if (this.progsel.scrutinio1) {
                let scrutinio1 = DateTime.fromISO(this.progsel.scrutinio1)
                console.log("CHECK DATE1", scrutinio1, adesso)
                window.FORMVOTIALUNNI_PRIMOSEMESTRE = scrutinio1 >= adesso ? '1' : '0'
                window.FORMVOTIALUNNI_SECONDOSEMESTRE = scrutinio1 < adesso ? '1' : '0'
                window.FORMVOTIALUNNI_DATAFINESEM = this.progsel.scrutinio1
                console.log("CHECK1:", window.FORMVOTIALUNNI_PRIMOSEMESTRE, window.FORMVOTIALUNNI_SECONDOSEMESTRE, window.FORMVOTIALUNNI_DATAFINESEM)
                if (scrutinio1 < adesso) {
                    this.dataChiuso = this.progsel.scrutinio1
                    console.log("Chiuso al", this.dataChiuso)
                }
            } else if (window.ENAC) {
                window.FORMVOTIALUNNI_PRIMOSEMESTRE = '1'
                window.FORMVOTIALUNNI_SECONDOSEMESTRE = '0'
                window.FORMVOTIALUNNI_DATAFINESEM = '2099-12-31'
            }
            this.tuttochiuso = false;//!!this.progsel.scrutinio2
            if (this.progsel.scrutinio2) {
                let scrutinio2 = DateTime.fromISO(this.progsel.scrutinio2)
                console.log("CHECK DATE2", scrutinio2, adesso)
                if (scrutinio2 < adesso) {
                    this.dataChiuso2 = this.progsel.scrutinio2
                }
            }
            let rselcal
            if (this.GREEN) {
                rselcal = "registrog.selcalnostage"
            } else {
                rselcal = "registro.selcalnostage"
            }
            var cals = await API.sqlprep(this, rselcal, [
                this.progsel.progettoid,
                this.loctimeSQL
            ]);
            this.cals = cals.data.dati
            this.moduli = moduli;
            this.loading = false;
            this.forceUpdate++; // per forzare alcuni aggiornamenti. 
        }
    },
    created: async function () {
        var url = new URL(window.location.href);
        var progettoid = url.searchParams.get("progettoid");

        var token = this.getTokenData().sub;
        var prgs;

        let tsedi = await API.sqlprep(this, "registro.selsedi", []);
        console.log("SEDI:", tsedi)
        let sedi = []
        for (let sede of tsedi.data.dati) {
            sedi[sede.sedeid] = sede.nome
        }

        if (progettoid) // dal SW potrebbe arrivare la richiesta per un progetto di una sede diversa
            prgs = await API.sqlprep(this, "registro.selprog", []);
        else if (this.getUserLIV() < 3)
            prgs = await API.sqlprep(this, "registro.selproginc", [token.user.docenteid, token.user.docenteid]);
        else if (this.getUserLIV() >= 5)
            prgs = await API.sqlprep(this, "registro.selprog", []);
        else
            prgs = await API.sqlprep(this, "registro.selprogsede", [token.user.sedeid]);

        this.progetti = prgs.data.dati
            .map(p => ({
                progettoid: p.progettoid,
                annualita: p.annualita,
                sedeid: p.sedeid,
                nome: sedi[p.sedeid] + ": " + p.numero + " - " + p.nome,
                noss: p.nosoftskills || NOSOFTSKILLS,
                nomr: p.nomodrel,
                nouf: p.nouf || window.GREEN,
                scrutinio1: p.scrutinio1,
                scrutinio2: p.scrutinio2,
            }))
            .sort((a, b) => {
                if (a.nome < b.nome) return -1;
                else if (a.nome > b.nome) return 1;
                else return 0;
            });

        var dtmp = await API.sqlprep(this, "registro.seldocs", []);
        var docs = [];
        dtmp.data.dati.map(d => {
            docs[d.docenteid] = d.nome;
        });
        this.docs = docs;

        if (progettoid) {
            this.progsel = this.progetti.find(p => p.progettoid == progettoid);
            this.noprogsel = true;
            this.fprogsel();
        }
        if (window.MODULIJOIN) {
            dtmp = await API.sqlprep(this, "registro.modulijoin", []);
            for (let t of dtmp.data.dati)
                this.modulijoin['' + t.m1] = t.m2
            console.log("modulijoin", this.modulijoin)
        }
    }
};
</script>
<style scoped>
div.foto {
    position: absolute;
    right: 0px;
    max-height: 130px;
    height: 130px;
}

div.foto img {
    max-height: 130px;
    height: 130px;
}

span.presenteNO {
    background-color: red;
}

span.presenteSI {
    background-color: green;
}

span.presenteNI {
    background-color: yellow;
}

span.giustificaSI {
    background-color: ORANGE;
}

textarea.argomento {
    width: 100%;
}

.blink {
    animation: blink 0.5s linear infinite;
}

@keyframes blink {
    0% {
        opacity: 0;
    }

    50% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

.datavoto {
    width: 110px;
    display: inline-block;
    border-style: ridge;
}

.voto {
    width: 30px;
    text-align: right;
    background-color: lightgreen;
    display: inline-block;
    border-style: ridge;
}

.fa-paperclip {
    color: blue;
}

.fa-trash {
    color: red;
}

th.rot90 {
    /* height: 200px;
  transform: rotate(-90deg) translateY(20px);
  transform-origin: left bottom 0; */
    min-width: 210px;
}

th.rot90 span {
    font-weight: normal;
}

table.registro td {
    vertical-align: top;
    border: 1px solid black;
}

table.registro th {
    vertical-align: bottom;
}

div.scroll {
    overflow: scroll;
}

.votohm {
    position: relative;
    left: -73px;
    width: 0px;
}

.votohmc {
    position: relative;
    left: -20px;
    width: 0px;
}

.w100 {
    width: 100%;
}

td.nowrap {
    white-space: nowrap;
    position: relative;
    vertical-align: top;
}

div.premedie {
    height: 100px;
}

div.premedie button {
    position: absolute;
    bottom: 90px;
    z-index: 99;
}

div.premedie2 {
    height: 30px;
}

div.premedie2 button {
    position: absolute;
    bottom: 20px;
    z-index: 99;
}

div.medie {
    position: absolute;
    bottom: 6px;
}

.clickme {
    cursor: pointer;
}
</style>
<style>
body.wait * {
    cursor: wait;
}

td.nowrap .vdatetime-popup {
    white-space: initial !important;
}

div.registro input.vdatetime-input {
    width: 100%;
}

div.mediaforced {
    background-color: lightskyblue;
}

table.prospettomoduli {
    width: 100%;
    table-layout: fixed;
}

table.prospettomoduli th {
    text-align: center;
}

table.prospettomoduli button {
    width: 100%;
}

span.liv7 {
    cursor: pointer;
}

span.saving {
    background-color: orange;
}

span.saved {
    background-color: lightgreen;
}
</style>